import { AxiosInstance } from 'axios';

export type CsatType = 'Module' | 'General';

export interface CsatBody {
  rating?: number;
  comment?: string;
  [key: string]: unknown;
}

export interface CsatListItem {
  id: number;
  type: CsatType;
  userId: number;
  moduleId: number | null;
  body: CsatBody | null;
  createdAt: string;
  updatedAt: string;
}

export interface CsatListRequest {
  page: number;
  pageSize: number;
  type?: CsatType;
  sortBy: 'Id' | 'UpdatedAt';
  sortDir: 'Asc' | 'Desc';
}

export function csatApi(client: AxiosInstance) {
  return {
    getList: (req: CsatListRequest) =>
      client.post<{ items: CsatListItem[]; totalCount: number }>('/api/v1/admin/csat/get-list', req),
    getById: (id: number) =>
      client.post<CsatListItem>('/api/v1/admin/csat/get-by-id', { id }),
  };
}
